import React, { useEffect, useState } from 'react';
import './OpeningScreen.css';
import firstImage from '../Assets/img1.png';
import secondImage from '../Assets/img2.png';
import thirdImage from '../Assets/img3.png';
import fourthImage from '../Assets/voucherImageBoardingScreen.png'; 
import { Link, useNavigate, useParams } from 'react-router-dom';

import firstImageDark from "../Assets/img1dark.png";
import secondImageDark from "../Assets/img2dark.png";
import thirdImageDark from "../Assets/img3dark.png";
import fourthImageDark from "../Assets/voucherImageBoardingScreen.png"; // Make sure to add dark version

const OnboardingScreens = () => {
  const [currentScreen, setCurrentScreen] = useState(0);
  const { theme } = useParams();
  const { localhost } = useParams();
  const navigate = useNavigate();
  

  const screens = [
    {
      title: "Ndiq pikët e tua",
      description: "Qëndro gjithmonë i informuar për shpërblimet e tua duke i ndjekur ato në kohë reale. Monitoro pikët e fituara nga çdo blerje dhe shiko sa afër je nivelit të ardhshëm. Progresi yt është gjithmonë vetëm një klik larg!",
      image: firstImage,
      imageDark: firstImageDark
    },
    {
      title: "Shpërblehu me Lehtësi",
      description: "Para se të paguash në dyqan, skano kodin QR në arkë për të fituar menjëherë pikë bonus. Shpërblehu në çast — zbritjet, kuponët dhe përfitime të tjera janë vetëm një skanim larg!",
      image: secondImage,
      imageDark: secondImageDark
    },
    {
      title: "Përdor Kuponët në Dyqan",
      description: "Nuk ke nevojë të printosh ose të tregosh një kod — kuponi yt dixhital përmban një barkod që mund të skanohet drejtpërdrejt nga shitësi në pikën e shitjes. Shpejt, thjesht dhe në mënyrë të sigurt. Mjafton ta tregosh dhe përfitimi është i yti!",
      image: fourthImage,
      imageDark: fourthImageDark
    },
    {
      title: "Zbulo Oferta Ekskluzive",
      description: "Përfito nga oferta speciale vetëm për ty. Qasu në promocione me kohë të kufizuar dhe oferta ekskluzive nga partnerët tanë, ndërsa grumbullon pikë. Sa më shumë ta përdorësh aplikacionin, aq më shumë përfitime do të zbulosh!",
      image: thirdImage,
      imageDark: thirdImageDark
    },
   
  ];
  
  const handleNext = () => {
    if (currentScreen < screens.length - 1) {
      setCurrentScreen(currentScreen + 1);
    } else {

   
    }
  };

  const handleSkip = () => {
    setCurrentScreen(screens.length - 1);
  };

  const handleRedirect = () => {
    window.open("https://redona.ai", "_self"); 
  };
  
  
  useEffect(() => {
    if (theme === "light") {
      document.body.classList.add("light-theme");
    } else {
      document.body.classList.remove("light-theme");
    }
    
    return () => {
      document.body.classList.remove("light-theme");
    };
  }, [theme]);

  const onboardingContainer = theme === "light" ? "onboarding-container-light" : "onboarding-container";
  const title = theme === "light" ? "title-light" : "title";
  const description = theme === "light" ? "description-light" : "description";
  const imagePlaceholder = theme === "light" ? "image-placeholder-light" : "image-placeholder";

  return (
    <div className={onboardingContainer}>
      <div className={imagePlaceholder}>
        <img 
          src={theme === "light" ? screens[currentScreen].image : screens[currentScreen].imageDark} 
          alt={screens[currentScreen].title}
          className="onboarding-image" 
        />
      </div>
      
      <div className="content-container">
        <h2 className={title}>{screens[currentScreen].title}</h2>
        <p className={description}>{screens[currentScreen].description}</p>
      </div>
      
      <div className="indicator-container">
        {screens.map((_, index) => (
          <div 
            key={index} 
            className={`indicator ${index === currentScreen ? 'active' : ''}`}
          />
        ))}
      </div>
      
      <div className="button-container">
        {currentScreen < screens.length - 1 ? (
          <>
            <button className="skip-button" onClick={handleSkip}>Skip</button>
            <button className="next-button" onClick={handleNext}>Next</button>
          </>
        ) : (
     
          <button className="get-started-button" onClick={handleRedirect}>Get Started</button>
            
        )}
      </div>
    </div>
  );
};

export default OnboardingScreens;